<style lang="scss" scoped>
  $leftWidth: 180px;
  .content-part {
    .content-left {
      width: $leftWidth;
    }

    .content-right {
      > h3 {
        left: $leftWidth;
      }

      left: $leftWidth;
    }
  }
</style>

<template>
  <div>
    <div class="content-part">
      <div class="content-left flex">
        <h2 class="clearfix right-title">{{leftTitle}}</h2>
        <ul class="show-list">
          <li class="list-style" v-for="item in pageSets" @click="showPart(item)" :key="item.key"
              v-bind:class="{ 'active' : index===item.key}"><span>{{ item.name }}</span>
          </li>
        </ul>
        <div class="btn-group">
          <el-button type="success" @click="onSubmit" :disabled="doing">保存订单</el-button>
        </div>
      </div>
      <div class="content-right content-padding order-form">
        <h3>{{ title }}</h3>
        <base-info ref="baseInfo" v-show="index === 0" :order="order" @clearGoodsList="clearGoodsList"/>
        <oms-form-row label="" :span="4" v-show="index === 0" style="margin-top: 10px">
          <el-button type="primary" @click="showPart(pageSets[1])">添加货品</el-button>
        </oms-form-row>
        <goods-info ref="goodInfo" v-show="index === 1" @addItem="addItem"
                    @deleteItem="deleteItem"
                    :goodsList="order.details" :baseForm="baseForm"/>
      </div>
    </div>
  </div>
</template>
<script>
  import BaseInfo from './base.vue';
  import GoodsInfo from './transform-goods-list';
  import {BSPOrder} from '@/resources';
  import orderMixin from '@/mixins/orderMixin';

  export default {
    props: {
      orderId: {
        type: String
      },
      defaultIndex: {
        type: Number
      }
    },
    mixins: [orderMixin],
    components: {BaseInfo, GoodsInfo},
    data() {
      return {
        order: {},
        baseForm: {},
        index: 0,
        title: '',
        leftTitle: '',
        doing: false
      };
    },
    watch: {
      defaultIndex(val) {
        this.index = 0;
        this.title = this.pageSets[0].name;
        this.resetForm();
        if (val === 5) {
          this.leftTitle = this.isNeedOrder ? '销售订单' : '销售退货订单';
          this.queryDetail();
        }
      },
      index(val) {
        if (val !== 1) return;
        this.baseForm = this.$refs.baseInfo.form;
      }
    },
    computed: {
      pageSets() {
        let menu = [];
        menu.push({name: '基本信息', key: 0});
        menu.push({name: '添加货品', key: 1});
        return menu;
      },
      isNeedOrder() { // 需求订单
        return this.$route.meta.isNeed;
      },
      isPurchaseReturnOrder() { // 采购退货单
        return this.$route.meta.isPurchaseReturn;
      }
    },
    methods: {
      queryDetail() {
        if (!this.orderId) return;
        BSPOrder.get(this.orderId).then(res => {
          res.data.details.forEach(i => {
            i.amount = i.orderAmount;
            i.unitPrice = i.orderPrice;
            i.code = i.goodsCode;
            i.specifications = i.specification;
            i.copyGoodsId = i.goodsId;
            i.isCopy = false;
            if (this.isNeedOrder) {
              i.storeId = '';
              i.batchNumber = '';
              i.batchNumberId = '';
              i.batchNumberList = [];
              i.count = '';
              i.productionDate = '';
              i.expirationDate = '';
              i.supplyManufacturersName = '';
              i.warehouseCode = '';
            }
          });
          this.order = {
            id: res.data.id,
            upstreamOrgDhsId: res.data.downstreamOrgId,
            upstreamOrgCode: res.data.downstreamOrgCode,
            upstreamCreditCode: res.data.downstreamCreditCode,
            upstreamOrgName: res.data.upstreamOrgName,
            downstreamOrgDhsId: res.data.upstreamOrgId,
            downstreamOrgName: res.data.upstreamOrgName,
            downstreamCreditCode: res.data.upstreamOrgCode,
            downstreamOrgCode: res.data.upstreamOrgCode,
            goodsType: res.data.orderGoodsType,
            type: '1',
            bizType: this.isNeedOrder ? '2-0' : '1-1',
            orderNo: '',
            transportationMeans: '',
            thirdLogisticsDhsId: res.data.thirdLogisticsId,
            shippingAddress: '',
            upstreamOrgAddress: '',
            orderThirdNo: res.data.orderNo,
            transportationCondition: res.data.transportationCondition,
            estimatedExecutionTime: res.data.estimatedExecutionTime,
            logisticsCentreName: '',
            consigneeName: '',
            consigneePhone: '',
            qualifiedFlag: true,
            details: res.data.details
          };
        });
      },
      showPart(item) {
        this.index = item.key;
        this.title = item.name;
      },
      resetForm() {
        const baseInfo = this.$refs.baseInfo;
        baseInfo.resetForm();
      },
      clearGoodsList() {
        const goodInfo = this.$refs.goodInfo;
        goodInfo.goodsList.forEach(i => {
          i.storeId = '';
          i.batchNumberList = [];
          goodInfo.batchNumberIdChange(i);
        });
        // this.$notify.info('改变物流中心，会清空货品所选批号，请重新选择批号!');
      },
      addItem(item) {
        let newItem = JSON.parse(JSON.stringify(item));
        let index = this.order.details.indexOf(item);
        newItem.copyGoodsId += '-' + Math.random() * 1000;
        newItem.isCopy = true;
        newItem.count = '';
        newItem.amount = '';
        newItem.productionDate = '';
        newItem.expirationDate = '';
        newItem.batchNumber = '';
        newItem.batchNumberId = '';
        newItem.supplyManufacturersName = '';
        newItem.warehouseCode = '';
        newItem.storeId = '';
        item.batchNumberList = [];
        this.order.details.splice(index + 1, 0, newItem);
      },
      deleteItem(item) {
        let index = this.order.details.indexOf(item);
        this.order.details.splice(index, 1);
      },
      onSubmit() {
        const baseInfo = this.$refs.baseInfo;
        const goodInfo = this.$refs.goodInfo;
        baseInfo.$refs.form.validate(valid => {
          if (!valid) {
            this.index = 0;
            return;
          }
          if (this.doing) return;
          // 需求订单
          if (this.isNeedOrder) {
            if (goodInfo.goodsList.some(s => !s.batchNumber && (!s.amount && s.amount !== 0))) return this.$notify.info('请选择货品批号');
            if (goodInfo.goodsList.some(s => !s.amount && s.amount !== 0)) return this.$notify.info('请输入货品数量');
            if (goodInfo.goodsList.some(s => s.amount > s.count)) return this.$notify.info('输入的货品数量大于当前批号的可用库存');
            for (let i = 0; i < goodInfo.goodsList.length; i++) {
              let item = goodInfo.goodsList[i];
              let list = goodInfo.goodsList.filter(f => f.goodsId === item.goodsId&& f.goodsExternalId === item.goodsExternalId);
              let sum = 0;
              list.forEach(a => sum += a.amount);
              if (sum > item.orderAmount) {
                return this.$notify.warning({
                  duration: 2000,
                  message: `货品"${item.goodsName}"的发货数量不能大于货品需求数`
                });
              }
            }
          }
          if (goodInfo.goodsList.filter(f => f.amount && f.amount !== 0).length === 0) return this.$notify.info('请输入货品数量');
          baseInfo.form.requirementOrderId = this.orderId;
          const order = Object.assign({}, baseInfo.form);
          order.type = this.type; // 订单类型
          // 库存数量不为0的货品不传后台
          order.detailList = goodInfo.goodsList.filter(f => f.amount && f.amount !== 0).map(m => ({
            goodsId: m.goodsId,
            goodsName: m.goodsName,
            goodsCode: m.code,
            orderAmount: m.amount,
            orderPrice: m.unitPrice,
            batchNumber: m.batchNumber,
            batchNumberId: m.batchNumberId,
            orderDetailId: m.orderDetailId
          }));
          // goodsExternalCode赋值
          order.detailList.forEach(f => {
            let temp=order.details.filter(t => t.orderDetailId === f.orderDetailId);
            if (temp&&temp.length>0){
              f.goodsExternalCode=temp[0].goodsExternalCode;
            }
          })
          order.id = '';
          this.doing = true;
          BSPOrder.save({order}).then(res => {
            this.$notify.success(`新增${this.leftTitle}成功`);
            this.doing = false;
            this.$emit('refresh');
            this.resetForm();
          }).catch(e => {
            this.doing = false;
            this.$notifyError(e, `新增${this.leftTitle}失败`);
          });
        });
      }
    }
  };
</script>
